import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  AppBar,
  Toolbar,
  IconButton,
  TextField,
  Button,
  Pagination,
  CircularProgress,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Ícono de retroceso
import { useLocation, useNavigate } from "react-router-dom"; // Para la navegación
import { UrlApiEnvasado } from "../../../../../services/apirest";
import PriceItem from "../componentePanel/PriceItem";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import TrendingFlatIcon from "@mui/icons-material/TrendingFlat";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import WarningIcon from "@mui/icons-material/Warning";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import moment from "moment/moment";
import PersonIcon from "@mui/icons-material/Person";
import PropaneTankIcon from "@mui/icons-material/PropaneTank";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useFechas } from "../../../context/FechaContext";
import { verEnviarPDFenvasado } from "../../../../../services/services";

function PanelSucursal() {
  let location = useLocation();
  const navigate = useNavigate(); // Hook para navegación

  const {
    desdeButano,
    hastaButano,
    desdePropano,
    hastaPropano,
    setDesdeButano,
    setHastaButano,
    setDesdePropano,
    setHastaPropano,
  } = useFechas();

  const [desde, setDesde] = useState(
    location.state.tabla === "Butano" ? desdeButano : desdePropano
  );
  const [hasta, setHasta] = useState(
    location.state.tabla === "Butano" ? hastaButano : hastaPropano
  );

  useEffect(() => {
    if (location.state.tabla === "Butano") {
      setDesdeButano(desde);
      setHastaButano(hasta);
    } else {
      setDesdePropano(desde);
      setHastaPropano(hasta);
    }
  }, [desde, hasta]);

  const [preciosButano, setPreciosButano] = useState([]);
  const [preciosPropano, setPreciosPropano] = useState([]);
  const [xProductoButano, setxProductoButano] = useState([]);
  const [xProductoPropano, setxProductoPropano] = useState([]);
  const [topVendedores, setTopVendedores] = useState([]);
  const [topMoviles, setTopMoviles] = useState([]);
  const [butanoMayores, setButanoMayores] = useState([]);
  const [butanoMenores, setButanoMenores] = useState([]);
  const [propanoMayores, setPropanomayores] = useState([]);
  const [propanoMenores, setPropanoMenores] = useState([]);

  //loadings
  const [loadingPreciosButano, setLoadingPreciosButano] = useState();
  const [loadingPreciosPropano, setLoadingPreciosPropano] = useState();
  const [loadingxProductoButano, setLoadingxProductoButano] = useState();
  const [loadingxProductoPropano, setLoadingxProductoPropano] = useState();
  const [loadingTopVendedores, setLoadingTopVendedores] = useState();
  const [loadingTopMoviles, setLoadingTopMoviles] = useState();
  const [loadingButanoMayores, setLoadingButanoMayores] = useState();
  const [loadingButanoMenores, setLoadingButanoMenores] = useState();
  const [loadingPropanoMayores, setLoadingPropanomayores] = useState();
  const [loadingPropanoMenores, setLoadingPropanoMenores] = useState();

  const [origen, setOrigen] = useState("");
  useEffect(() => {
    if (location.state.row.origen === "bk1_aws_hipergas") {
      setOrigen("api/estadistica");
    } else if (location.state.row.origen === "bk1_aws_aogas") {
      setOrigen("db2/api/estadisticaaogas");
    }
  }, [location.state]);

  //paginacion vendedores
  const [page, setPage] = useState(1);
  const rowsPerPage = 5; // Número de filas por página

  // Calcular las filas que deben mostrarse
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const displayedVendedores = topVendedores.slice(startIndex, endIndex);

  // Manejar el cambio de página
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  //paginacion moviles
  const [pageMoviles, setPageMoviles] = useState(1);
  const rowsPerPageMoviles = 5; // Número de filas por página

  // Calcular las filas que deben mostrarse
  const startIndexMoviles = (pageMoviles - 1) * rowsPerPageMoviles;
  const endIndexMoviles = startIndexMoviles + rowsPerPageMoviles;
  const displayedMoviles = topMoviles.slice(startIndexMoviles, endIndexMoviles);

  // Manejar el cambio de página
  const handlePageChangeMoviles = (event, newPage) => {
    setPageMoviles(newPage);
  };
  //FETCHS
  // obtener preciosButano
  const obtenerPreciosButano = async () => {
    setLoadingPreciosButano(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/kgbutano/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setPreciosButano(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingPreciosButano(false);
    }
  };
  // PreciosPropano
  const obtenerPreciosPropano = async () => {
    setLoadingPreciosPropano(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/kgpropano/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setPreciosPropano(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingPreciosPropano(false);
    }
  };

  // xProductoButano
  const obtenerxProductoButano = async () => {
    setLoadingxProductoButano(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/xproductobutano/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setxProductoButano(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingxProductoButano(false);
    }
  };

  // xProductoPropano
  const obtenerxProductoPropano = async () => {
    setLoadingxProductoPropano(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/xproductopropano/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setxProductoPropano(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingxProductoPropano(false);
    }
  };

  // topVendedores
  const obtenerTopVendedores = async () => {
    setLoadingTopVendedores(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/topvendedores/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setTopVendedores(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingTopVendedores(false);
    }
  };

  // TopMoviles
  const obtenerTopMoviles = async () => {
    setLoadingTopMoviles(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/topmoviles/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setTopMoviles(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingTopMoviles(false);
    }
  };

  // ButanoMayores
  const obtenerButanoMayores = async () => {
    setLoadingButanoMayores(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/butanomayores/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setButanoMayores(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingButanoMayores(false);
    }
  };  

  // ButanoMenores
  const obtenerButanoMenores = async () => {
    setLoadingButanoMenores(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/butanomenores/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setButanoMenores(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingButanoMenores(false);
    }
  };
  // PropanoMayores
  const obtenerPropanoMayores = async () => {
    setLoadingPropanomayores(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/propanomayores/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setPropanomayores(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingPropanomayores(false);
    }
  };

  // PropanoMenores
  const obtenerPropanoMenores = async () => {
    setLoadingPropanoMenores(true);
    try {
      // Fetch para ranking menores
      const response = await fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/propanomenores/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      );
      const data = await response.json();
      setPropanoMenores(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingPropanoMenores(false);
    }
  };

  useEffect(() => {
    // if (origen !== "") {
      obtenerPreciosButano();
      obtenerPreciosPropano();
      obtenerxProductoButano();
      obtenerxProductoPropano();
      obtenerTopVendedores();
      obtenerTopMoviles();
      obtenerButanoMayores();
      obtenerButanoMenores();
      obtenerPropanoMayores();
      obtenerPropanoMenores();
    // }
  }, []);

  const handleUpdate = () => {
    obtenerPreciosButano();
    obtenerPreciosPropano();
    obtenerxProductoButano();
    obtenerxProductoPropano();
    obtenerTopVendedores();
    obtenerTopMoviles();
    obtenerButanoMayores();
    obtenerButanoMenores();
    obtenerPropanoMayores();
    obtenerPropanoMenores();
  };

  const handleRowClick = (row) => {
    // Redirigir a /verfactura y pasar los datos de la fila como state
    verEnviarPDFenvasado(row.id_factura, 0)
    // navigate("/verfacturanetizar", {
    //   state: {
    //     tipo: row.frr_tipo_comp,
    //     suc: row.frr_suc,
    //     nro: row.frr_nro,
    //     origen: location.state.row.origen,
    //   },
    // });
  };

  return (
    <div style={{ backgroundColor: "#d7d7d7" }}>
      <AppBar
        position="static"
        sx={{ backgroundColor: "#1F618D", position: "relative" }}
      >
        <Toolbar sx={{ minHeight: 64 }}>
          {/* Botón de volver a la izquierda */}
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h6"
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              textAlign: "center",
              pointerEvents: "none", // Evita que el título intercepte clicks
            }}
          >
            Panel de Sucursal {location.state.row.nombre_sucursal}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "#EAF2F8", fontStyle: "italic", marginLeft: "auto" }}
          >
            * Todos los precios están expresados sin impuestos
          </Typography>
        </Toolbar>
      </AppBar>

      <Box sx={{ backgroundColor: "#fff", minHeight: "100vh", p: 3 }}>
        {/* Contenido del Panel */}
        <Grid
          mb={2}
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
        >
          <Grid item xs={12} md={3}>
            <TextField
              label="Desde"
              type="date"
              value={desde}
              onChange={(e) => setDesde(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#1F618D",
                  },
                  "&:hover fieldset": {
                    borderColor: "#1F618D",
                  },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Hasta"
              type="date"
              value={hasta}
              onChange={(e) => setHasta(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#1F618D",
                  },
                  "&:hover fieldset": {
                    borderColor: "#1F618D",
                  },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Button
              variant="contained"
              onClick={handleUpdate}
              size="medium"
              fullWidth
              sx={{
                backgroundColor: "#1F618D",
                color: "#fff",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#154360",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 8px rgba(31, 97, 141, 0.3)",
                },
                transition: "all 0.3s ease",
                height: "40px",
              }}
              startIcon={<RefreshIcon />}
            >
              Actualizar
            </Button>
          </Grid>
        </Grid>
        {/* Sección de Precios x kg */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          {/* Tarjeta de Precios de Butano */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #1F618D",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <LocalFireDepartmentIcon
                    sx={{ color: "#FF6B35", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    PRECIOS POR KG - BUTANO
                  </Typography>
                </Box>

                {loadingPreciosButano ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "120px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#1F618D" }} />
                  </Box>
                ) : preciosButano && preciosButano[0] ? (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(120px, 1fr))",
                      gap: 2,
                      mt: 2,
                    }}
                  >
                    <PriceItem
                      label="Promedio"
                      value={preciosButano[0].precio_promedio_por_kilo.toFixed(2)}
                      icon={<TrendingFlatIcon sx={{ color: "#5D6D7E" }} />}
                    />
                    <PriceItem
                      label="Máximo"
                      value={preciosButano[0].precio_maximo_por_kilo.toFixed(2)}
                      icon={<TrendingUpIcon sx={{ color: "#27AE60" }} />}
                    />
                    <PriceItem
                      label="Mínimo"
                      value={preciosButano[0].precio_minimo_por_kilo.toFixed(2)}
                      icon={<TrendingDownIcon sx={{ color: "#E74C3C" }} />}
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "120px",
                      color: "#7F8C8D",
                    }}
                  >
                    <ErrorOutlineIcon sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="body2">
                      No hay datos disponibles
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Precios Propano */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #1F618D",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <LocalFireDepartmentIcon
                    sx={{ color: "#FF6B35", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    PRECIOS POR KG - PROPANO
                  </Typography>
                </Box>

                {loadingPreciosPropano ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "120px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#1F618D" }} />
                  </Box>
                ) : preciosPropano && preciosPropano[0] ? (
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(120px, 1fr))",
                      gap: 2,
                      mt: 2,
                    }}
                  >
                    <PriceItem
                      label="Promedio"
                      value={preciosPropano[0].precio_promedio_por_kilo.toFixed(2)}
                      icon={<TrendingFlatIcon sx={{ color: "#5D6D7E" }} />}
                    />
                    <PriceItem
                      label="Máximo"
                      value={preciosPropano[0].precio_maximo_por_kilo.toFixed(2)}
                      icon={<TrendingUpIcon sx={{ color: "#27AE60" }} />}
                    />
                    <PriceItem
                      label="Mínimo"
                      value={preciosPropano[0].precio_minimo_por_kilo.toFixed(2)}
                      icon={<TrendingDownIcon sx={{ color: "#E74C3C" }} />}
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "120px",
                      color: "#7F8C8D",
                    }}
                  >
                    <ErrorOutlineIcon sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="body2">
                      No hay datos disponibles
                    </Typography>
                  </Box>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Tablas de Precios x kg */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          {/* Tabla Butano */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #1F618D",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <PropaneTankIcon
                    sx={{ color: "#FF6B35", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    PRECIOS POR PRODUCTO - BUTANO
                  </Typography>
                </Box>

                {loadingxProductoButano ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#1F618D" }} />
                  </Box>
                ) : (
                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "400px",
                      overflow: "auto",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                        height: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#1F618D",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#f5f7fa",
                              borderBottom: "2px solid #1F618D",
                            }}
                          >
                            Producto
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#f5f7fa",
                              borderBottom: "2px solid #1F618D",
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end"
                            >
                              <TrendingFlatIcon
                                sx={{ color: "#5D6D7E", fontSize: 18, mr: 0.5 }}
                              />
                              Promedio
                            </Box>
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#f5f7fa",
                              borderBottom: "2px solid #1F618D",
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end"
                            >
                              <TrendingUpIcon
                                sx={{ color: "#E74C3C", fontSize: 18, mr: 0.5 }}
                              />
                              Máximo
                            </Box>
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#f5f7fa",
                              borderBottom: "2px solid #1F618D",
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end"
                            >
                              <TrendingDownIcon
                                sx={{ color: "#27AE60", fontSize: 18, mr: 0.5 }}
                              />
                              Mínimo
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {xProductoButano.map((producto, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:nth-of-type(odd)": {
                                backgroundColor: "#ffffff",
                              },
                              "&:nth-of-type(even)": {
                                backgroundColor: "#f8f9fa",
                              },
                              "&:hover": { backgroundColor: "#e9f5ff" },
                              transition: "background-color 0.2s ease",
                            }}
                          >
                            <TableCell
                              sx={{ color: "#2C3E50", fontWeight: "500" }}
                            >
                              {producto.producto}
                            </TableCell>
                            <TableCell align="right" sx={{ color: "#2C3E50" }}>
                              ${producto.precio_promedio_por_kilo.toFixed(2)}
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{ color: "#27AE60", fontWeight: "500" }}
                            >
                              ${producto.precio_maximo_por_kilo.toFixed(2)}
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{ color: "#E74C3C", fontWeight: "500" }}
                            >
                              ${producto.precio_minimo_por_kilo.toFixed(2)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Tabla Propano */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #1F618D",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <PropaneTankIcon
                    sx={{ color: "#FF6B35", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    PRECIOS POR PRODUCTO - PROPANO
                  </Typography>
                </Box>

                {loadingxProductoPropano ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#1F618D" }} />
                  </Box>
                ) : (
                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "400px",
                      overflow: "auto",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                        height: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#1F618D",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#f5f7fa",
                              borderBottom: "2px solid #1F618D",
                            }}
                          >
                            Producto
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#f5f7fa",
                              borderBottom: "2px solid #1F618D",
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end"
                            >
                              <TrendingFlatIcon
                                sx={{ color: "#5D6D7E", fontSize: 18, mr: 0.5 }}
                              />
                              Promedio
                            </Box>
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#f5f7fa",
                              borderBottom: "2px solid #1F618D",
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end"
                            >
                              <TrendingUpIcon
                                sx={{ color: "#E74C3C", fontSize: 18, mr: 0.5 }}
                              />
                              Máximo
                            </Box>
                          </TableCell>
                          <TableCell
                            align="right"
                            sx={{
                              fontWeight: "bold",
                              color: "#1F618D",
                              backgroundColor: "#f5f7fa",
                              borderBottom: "2px solid #1F618D",
                            }}
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              justifyContent="flex-end"
                            >
                              <TrendingDownIcon
                                sx={{ color: "#27AE60", fontSize: 18, mr: 0.5 }}
                              />
                              Mínimo
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {xProductoPropano.map((producto, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:nth-of-type(odd)": {
                                backgroundColor: "#ffffff",
                              },
                              "&:nth-of-type(even)": {
                                backgroundColor: "#f8f9fa",
                              },
                              "&:hover": { backgroundColor: "#e9f5ff" },
                              transition: "background-color 0.2s ease",
                            }}
                          >
                            <TableCell
                              sx={{ color: "#2C3E50", fontWeight: "500" }}
                            >
                              {producto.producto}
                            </TableCell>
                            <TableCell align="right" sx={{ color: "#2C3E50" }}>
                              ${producto.precio_promedio_por_kilo.toFixed(2)}
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{ color: "#27AE60", fontWeight: "500" }}
                            >
                              ${producto.precio_maximo_por_kilo.toFixed(2)}
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{ color: "#E74C3C", fontWeight: "500" }}
                            >
                              ${producto.precio_minimo_por_kilo.toFixed(2)}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Top de Mejores Vendedores y Móviles */}
        <Grid container spacing={3} sx={{ mb: 3 }}>
          {/* Top Vendedores */}
          <Grid item xs={12} md={12}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #1F618D",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <PersonIcon sx={{ color: "#FFD700", fontSize: 28, mr: 1 }} />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    TOP VENDEDORES
                  </Typography>
                </Box>

                {loadingTopVendedores ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "300px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#1F618D" }} />
                  </Box>
                ) : (
                  <>
                    <TableContainer
                      component={Paper}
                      sx={{
                        borderRadius: "8px",
                        boxShadow: "none",
                        border: "1px solid #e0e0e0",
                        maxHeight: "500px",
                        overflow: "auto",
                        "&::-webkit-scrollbar": {
                          width: "6px",
                          height: "6px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#1F618D",
                          borderRadius: "3px",
                        },
                      }}
                    >
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#1F618D",
                                backgroundColor: "#f5f7fa",
                                borderRight: "2px solid #e0e0e0",
                                minWidth: "150px",
                                position: "sticky",
                                left: 0,
                                zIndex: 2,
                              }}
                            >
                              Vendedor
                            </TableCell>

                            {/* Butano Header */}
                            <TableCell
                              align="center"
                              colSpan={4}
                              sx={{
                                fontWeight: "bold",
                                color: "#1F618D",
                                backgroundColor: "#E3F2FD",
                                borderRight: "2px solid #e0e0e0",
                              }}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <LocalFireDepartmentIcon
                                  sx={{ color: "#FF6B35", fontSize: 20, mr: 1 }}
                                />
                                BUTANO
                              </Box>
                            </TableCell>

                            {/* Propano Header */}
                            <TableCell
                              align="center"
                              colSpan={4}
                              sx={{
                                fontWeight: "bold",
                                color: "#1F618D",
                                backgroundColor: "#e8f5e9",
                              }}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <LocalFireDepartmentIcon
                                  sx={{ color: "#FF8C42", fontSize: 20, mr: 1 }}
                                />
                                PROPANO
                              </Box>
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#1F618D",
                                backgroundColor: "#f5f7fa",
                                borderRight: "2px solid #e0e0e0",
                                position: "sticky",
                                left: 0,
                                zIndex: 2,
                              }}
                            ></TableCell>

                            {/* Butano Subheaders */}
                            {["Kg. Vendidos", "$ Prom", "$ Max", "$ Min"].map(
                              (header, idx) => (
                                <TableCell
                                  key={`butano-${idx}`}
                                  align="right"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#1F618D",
                                    backgroundColor: "#E3F2FD",
                                    borderRight:
                                      idx < 3
                                        ? "1px solid #e0e0e0"
                                        : "2px solid #e0e0e0",
                                  }}
                                >
                                  {header}
                                </TableCell>
                              )
                            )}

                            {/* Propano Subheaders */}
                            {["Kg. Vendidos", "$ Prom", "$ Max", "$ Min"].map(
                              (header, idx) => (
                                <TableCell
                                  key={`propano-${idx}`}
                                  align="right"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#1F618D",
                                    backgroundColor: "#e8f5e9",
                                    borderRight:
                                      idx < 3 ? "1px solid #e0e0e0" : "none",
                                  }}
                                >
                                  {header}
                                </TableCell>
                              )
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {displayedVendedores.map((vendedor, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                "&:nth-of-type(odd)": {
                                  "& > *:not(:first-child)": {
                                    backgroundColor: "#ffffff",
                                  },
                                },
                                "&:nth-of-type(even)": {
                                  "& > *:not(:first-child)": {
                                    backgroundColor: "#f8f9fa",
                                  },
                                },
                                "&:hover": { backgroundColor: "#e9f5ff" },
                                transition: "background-color 0.2s ease",
                              }}
                            >
                              {/* Nombre Vendedor */}
                              <TableCell
                                sx={{
                                  color: "#2C3E50",
                                  fontWeight: "500",
                                  backgroundColor: "#f5f7fa !important",
                                  borderRight: "2px solid #e0e0e0",
                                  position: "sticky",
                                  left: 0,
                                  zIndex: 1,
                                }}
                              >
                                {vendedor.vendedor}
                              </TableCell>

                              {/* Datos Butano */}
                              {[
                                vendedor.kilos_vendidos_butano,
                                vendedor.precio_promedio_butano?.toFixed(2) ??
                                  "0.00",
                                vendedor.precio_maximo_butano?.toFixed(2) ??
                                  "0.00",
                                vendedor.precio_minimo_butano?.toFixed(2) ??
                                  "0.00",
                              ].map((value, idx) => (
                                <TableCell
                                  key={`butano-data-${idx}`}
                                  align="right"
                                  sx={{
                                    color:
                                      idx === 0
                                        ? "#2C3E50"
                                        : idx === 3
                                        ? "#E74C3C"
                                        : idx === 2
                                        ? "#27AE60"
                                        : "#2C3E50",
                                    fontWeight: idx > 0 ? "500" : "400",
                                    backgroundColor:
                                      index % 2 === 0 ? "#E3F2FD" : "#D8EBFD",
                                    borderRight:
                                      idx < 3
                                        ? "1px solid #e0e0e0"
                                        : "2px solid #e0e0e0",
                                  }}
                                >
                                  {idx === 0 ? value : `$${value}`}
                                </TableCell>
                              ))}

                              {/* Datos Propano */}
                              {[
                                vendedor.kilos_vendidos_propano,
                                vendedor.precio_promedio_propano?.toFixed(2) ??
                                  "0.00",
                                vendedor.precio_maximo_propano?.toFixed(2) ??
                                  "0.00",
                                vendedor.precio_minimo_propano?.toFixed(2) ??
                                  "0.00",
                              ].map((value, idx) => (
                                <TableCell
                                  key={`propano-data-${idx}`}
                                  align="right"
                                  sx={{
                                    color:
                                      idx === 0
                                        ? "#2C3E50"
                                        : idx === 3
                                        ? "#E74C3C"
                                        : idx === 2
                                        ? "#27AE60"
                                        : "#2C3E50",
                                    fontWeight: idx > 0 ? "500" : "400",
                                    backgroundColor:
                                      index % 2 === 0 ? "#e8f5e9" : "#d8edda",
                                  }}
                                >
                                  {idx === 0 ? value : `$${value}`}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {/* Paginación */}
                    <Box
                      sx={{ display: "flex", justifyContent: "center", mt: 3 }}
                    >
                      <Pagination
                        count={Math.ceil(topVendedores.length / rowsPerPage)}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        shape="rounded"
                        sx={{
                          "& .MuiPaginationItem-root": {
                            color: "#1F618D",
                            fontWeight: "500",
                          },
                          "& .Mui-selected": {
                            backgroundColor: "#1F618D !important",
                            color: "white",
                          },
                          "& .MuiPaginationItem-root:hover": {
                            backgroundColor: "#E3F2FD",
                          },
                        }}
                      />
                    </Box>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Top Móviles */}
          <Grid item xs={12} md={12}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
                boxShadow: "0 8px 16px rgba(31, 97, 141, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #1F618D",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(31, 97, 141, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <LocalShippingIcon
                    sx={{ color: "#5D6D7E", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                    }}
                  >
                    TOP MÓVILES
                  </Typography>
                </Box>

                {loadingTopMoviles ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "300px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#1F618D" }} />
                  </Box>
                ) : (
                  <>
                    <TableContainer
                      component={Paper}
                      sx={{
                        borderRadius: "8px",
                        boxShadow: "none",
                        border: "1px solid #e0e0e0",
                        maxHeight: "500px",
                        overflow: "auto",
                        "&::-webkit-scrollbar": {
                          width: "6px",
                          height: "6px",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#1F618D",
                          borderRadius: "3px",
                        },
                      }}
                    >
                      <Table size="small" stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#1F618D",
                                backgroundColor: "#f5f7fa",
                                borderRight: "2px solid #e0e0e0",
                                minWidth: "150px",
                                position: "sticky",
                                left: 0,
                                zIndex: 2,
                              }}
                            >
                              Móvil
                            </TableCell>

                            {/* Butano Header */}
                            <TableCell
                              align="center"
                              colSpan={4}
                              sx={{
                                fontWeight: "bold",
                                color: "#1F618D",
                                backgroundColor: "#E3F2FD",
                                borderRight: "2px solid #e0e0e0",
                              }}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <LocalFireDepartmentIcon
                                  sx={{ color: "#FF6B35", fontSize: 20, mr: 1 }}
                                />
                                BUTANO
                              </Box>
                            </TableCell>

                            {/* Propano Header */}
                            <TableCell
                              align="center"
                              colSpan={4}
                              sx={{
                                fontWeight: "bold",
                                color: "#1F618D",
                                backgroundColor: "#e8f5e9",
                              }}
                            >
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                              >
                                <LocalFireDepartmentIcon
                                  sx={{ color: "#FF8C42", fontSize: 20, mr: 1 }}
                                />
                                PROPANO
                              </Box>
                            </TableCell>
                          </TableRow>

                          <TableRow>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#1F618D",
                                backgroundColor: "#f5f7fa",
                                borderRight: "2px solid #e0e0e0",
                                position: "sticky",
                                left: 0,
                                zIndex: 2,
                              }}
                            ></TableCell>

                            {/* Butano Subheaders */}
                            {["Kg. Vendidos", "$ Prom", "$ Max", "$ Min"].map(
                              (header, idx) => (
                                <TableCell
                                  key={`butano-${idx}`}
                                  align="right"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#1F618D",
                                    backgroundColor: "#E3F2FD",
                                    borderRight:
                                      idx < 3
                                        ? "1px solid #e0e0e0"
                                        : "2px solid #e0e0e0",
                                  }}
                                >
                                  {header}
                                </TableCell>
                              )
                            )}

                            {/* Propano Subheaders */}
                            {["Kg. Vendidos", "$ Prom", "$ Max", "$ Min"].map(
                              (header, idx) => (
                                <TableCell
                                  key={`propano-${idx}`}
                                  align="right"
                                  sx={{
                                    fontWeight: "bold",
                                    color: "#1F618D",
                                    backgroundColor: "#e8f5e9",
                                    borderRight:
                                      idx < 3 ? "1px solid #e0e0e0" : "none",
                                  }}
                                >
                                  {header}
                                </TableCell>
                              )
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {displayedMoviles.map((movil, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                "&:nth-of-type(odd)": {
                                  "& > *:not(:first-child)": {
                                    backgroundColor: "#ffffff",
                                  },
                                },
                                "&:nth-of-type(even)": {
                                  "& > *:not(:first-child)": {
                                    backgroundColor: "#f8f9fa",
                                  },
                                },
                                "&:hover": { backgroundColor: "#e9f5ff" },
                                transition: "background-color 0.2s ease",
                              }}
                            >
                              {/* Nombre Móvil */}
                              <TableCell
                                sx={{
                                  color: "#2C3E50",
                                  fontWeight: "500",
                                  backgroundColor: "#f5f7fa !important",
                                  borderRight: "2px solid #e0e0e0",
                                  position: "sticky",
                                  left: 0,
                                  zIndex: 1,
                                }}
                              >
                                {movil.movil}
                              </TableCell>

                              {/* Datos Butano */}
                              {[
                                movil.kilos_vendidos_butano,
                                movil.precio_promedio_butano?.toFixed(2) ||
                                  "0.00",
                                movil.precio_maximo_butano?.toFixed(2) ||
                                  "0.00",
                                movil.precio_minimo_butano?.toFixed(2) ||
                                  "0.00",
                              ].map((value, idx) => (
                                <TableCell
                                  key={`butano-data-${idx}`}
                                  align="right"
                                  sx={{
                                    color:
                                      idx === 0
                                        ? "#2C3E50"
                                        : idx === 3
                                        ? "#E74C3C"
                                        : idx === 2
                                        ? "#27AE60"
                                        : "#2C3E50",
                                    fontWeight: idx > 0 ? "500" : "400",
                                    backgroundColor:
                                      index % 2 === 0 ? "#E3F2FD" : "#D8EBFD",
                                    borderRight:
                                      idx < 3
                                        ? "1px solid #e0e0e0"
                                        : "2px solid #e0e0e0",
                                  }}
                                >
                                  {idx === 0 ? value : `$${value}`}
                                </TableCell>
                              ))}

                              {/* Datos Propano */}
                              {[
                                movil.kilos_vendidos_propano,
                                movil.precio_promedio_propano?.toFixed(2) ||
                                  "0.00",
                                movil.precio_maximo_propano?.toFixed(2) ||
                                  "0.00",
                                movil.precio_minimo_propano?.toFixed(2) ||
                                  "0.00",
                              ].map((value, idx) => (
                                <TableCell
                                  key={`propano-data-${idx}`}
                                  align="right"
                                  sx={{
                                    color:
                                      idx === 0
                                        ? "#2C3E50"
                                        : idx === 3
                                        ? "#E74C3C"
                                        : idx === 2
                                        ? "#27AE60"
                                        : "#2C3E50",
                                    fontWeight: idx > 0 ? "500" : "400",
                                    backgroundColor:
                                      index % 2 === 0 ? "#e8f5e9" : "#d8edda",
                                  }}
                                >
                                  {idx === 0 ? value : `$${value}`}
                                </TableCell>
                              ))}
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    {/* Paginación */}
                    <Box
                      sx={{ display: "flex", justifyContent: "center", mt: 3 }}
                    >
                      <Pagination
                        count={Math.ceil(
                          topMoviles.length / rowsPerPageMoviles
                        )}
                        page={pageMoviles}
                        onChange={handlePageChangeMoviles}
                        color="primary"
                        shape="rounded"
                        sx={{
                          "& .MuiPaginationItem-root": {
                            color: "#1F618D",
                            fontWeight: "500",
                          },
                          "& .Mui-selected": {
                            backgroundColor: "#1F618D !important",
                            color: "white",
                          },
                          "& .MuiPaginationItem-root:hover": {
                            backgroundColor: "#E3F2FD",
                          },
                        }}
                      />
                    </Box>
                  </>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Facturas con mayor y menor precio */}
        <Grid container spacing={3}>
          {/* Tabla de Precios Máximos */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f0f9f5 0%, #e0f0ea 100%)",
                boxShadow: "0 8px 16px rgba(46, 204, 113, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #2ECC71", // Verde vibrante para mínimos
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(46, 204, 113, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <TrendingUpIcon
                    sx={{ color: "#2ECC71", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                      background: "linear-gradient(to right, #2ECC71, #27AE60)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    PRECIOS MÁXIMOS - BUTANO
                  </Typography>
                </Box>

                {loadingButanoMayores ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#2ECC71" }} />
                  </Box>
                ) : (
                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "400px",
                      overflow: "auto",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                        height: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#2ECC71",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          {[
                            "Vendedor",
                            "Patente",
                            "Cliente",
                            "Precio/Kilo",
                            "Fecha",
                          ].map((header, index) => (
                            <TableCell
                              key={index}
                              sx={{
                                fontWeight: "bold",
                                color: index === 3 ? "#2ECC71" : "#1F618D", // Verde solo para precio
                                backgroundColor: "#f0f9f5",
                                borderBottom: "2px solid #2ECC71",
                                minWidth: index === 2 ? "160px" : "auto",
                              }}
                            >
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {butanoMayores.map((item, index) => (
                          <TableRow
                            key={index}
                            onClick={() => handleRowClick(item)}
                            sx={{
                              "&:nth-of-type(odd)": {
                                backgroundColor: "#ffffff",
                              },
                              "&:nth-of-type(even)": {
                                backgroundColor: "#f0f9f5",
                              },
                              "&:hover": { backgroundColor: "#e8f5e9" }, // Rojo muy claro al hover
                              transition: "background-color 0.2s ease",
                            }}
                          >
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {item.name_vendedor}
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              <Box
                                sx={{
                                  backgroundColor: "#D5F5E3",
                                  borderRadius: "4px",
                                  p: "2px 4px",
                                  display: "inline-block",
                                  fontWeight: "500",
                                }}
                              >
                                {item.patente}
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {item.name_cliente_adi}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#27AE60",
                                fontSize: "0.875rem",
                                fontWeight: "600",
                              }}
                            >
                              ${item.precio_kilo.toFixed(2)}
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {moment(
                                item.ccd_fecha_mov,
                                "DD-MM-YYYY HH:mm" // Formato de entrada (como viene en tus datos)
                              ).format("DD/MM/YYYY HH:mm")}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Tabla de Precios Mínimos */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #fef6f5 0%, #f5e8e6 100%)",
                boxShadow: "0 8px 16px rgba(231, 76, 60, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #E74C3C", // Rojo intenso para minimos de propano
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(231, 76, 60, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <TrendingDownIcon
                    sx={{ color: "#FF8C42", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                      background: "linear-gradient(to right, #E74C3C, #FF8C42)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    PRECIOS MÍNIMOS - BUTANO
                  </Typography>
                </Box>

                {loadingButanoMenores ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#E74C3C" }} />
                  </Box>
                ) : (
                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "400px",
                      overflow: "auto",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                        height: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#E74C3C",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          {[
                            "Vendedor",
                            "Patente",
                            "Cliente",
                            "Precio/Kilo",
                            "Fecha",
                          ].map((header, index) => (
                            <TableCell
                              key={index}
                              sx={{
                                fontWeight: "bold",
                                color: index === 3 ? "#E74C3C" : "#1F618D", // Rojo solo para precio
                                backgroundColor: "#fef6f5",
                                borderBottom: "2px solid #E74C3C",
                                minWidth: index === 2 ? "160px" : "auto",
                              }}
                            >
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {butanoMenores.map((item, index) => (
                          <TableRow
                            key={index}
                            onClick={() => handleRowClick(item)}
                            sx={{
                              "&:nth-of-type(odd)": {
                                backgroundColor: "#ffffff",
                              },
                              "&:nth-of-type(even)": {
                                backgroundColor: "#fff5f4",
                              },
                              "&:hover": { backgroundColor: "#ffebee" }, // Verde muy claro al hover
                              transition: "background-color 0.2s ease",
                            }}
                          >
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {item.name_vendedor}
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              <Box
                                sx={{
                                  backgroundColor: "#FFE0B2",
                                  borderRadius: "4px",
                                  p: "2px 4px",
                                  display: "inline-block",
                                  fontWeight: "500",
                                }}
                              >
                                {item.patente}
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {item.name_cliente_adi}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#E74C3C",
                                fontSize: "0.875rem",
                                fontWeight: "600",
                              }}
                            >
                              ${item.precio_kilo.toFixed(2)}
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {moment(
                                item.ccd_fecha_mov,
                                "DD-MM-YYYY HH:mm" // Formato de entrada (como viene en tus datos)
                              ).format("DD/MM/YYYY HH:mm")}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Grid container spacing={3} mt={1}>
          {/* Tabla de Precios Máximos */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #f0f9f5 0%, #e0f0ea 100%)",
                boxShadow: "0 8px 16px rgba(46, 204, 113, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #2ECC71", // Verde vibrante para mínimos
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(46, 204, 113, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <TrendingUpIcon
                    sx={{ color: "#2ECC71", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                      background: "linear-gradient(to right, #2ECC71, #27AE60)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    PRECIOS MÁXIMOS - PROPANO
                  </Typography>
                </Box>

                {loadingPropanoMayores ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#2ECC71" }} />
                  </Box>
                ) : (
                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "400px",
                      overflow: "auto",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                        height: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#2ECC71",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          {[
                            "Vendedor",
                            "Patente",
                            "Cliente",
                            "Precio/Kilo",
                            "Fecha",
                          ].map((header, index) => (
                            <TableCell
                              key={index}
                              sx={{
                                fontWeight: "bold",
                                color: index === 3 ? "#2ECC71" : "#1F618D", // Verde solo para precio
                                backgroundColor: "#f0f9f5",
                                borderBottom: "2px solid #2ECC71",
                                minWidth: index === 2 ? "160px" : "auto",
                              }}
                            >
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {propanoMayores.map((item, index) => (
                          <TableRow
                            key={index}
                            onClick={() => handleRowClick(item)}
                            sx={{
                              "&:nth-of-type(odd)": {
                                backgroundColor: "#ffffff",
                              },
                              "&:nth-of-type(even)": {
                                backgroundColor: "#f0f9f5",
                              },
                              "&:hover": { backgroundColor: "#e8f5e9" },
                              transition: "background-color 0.2s ease",
                            }}
                          >
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {item.name_vendedor}
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              <Box
                                sx={{
                                  backgroundColor: "#D5F5E3",
                                  borderRadius: "4px",
                                  p: "2px 4px",
                                  display: "inline-block",
                                  fontWeight: "500",
                                }}
                              >
                                {item.patente}
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {item.name_cliente_adi}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#27AE60",
                                fontSize: "0.875rem",
                                fontWeight: "600",
                              }}
                            >
                              ${item.precio_kilo.toFixed(2)}
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {moment(
                                item.ccd_fecha_mov,
                                "DD-MM-YYYY HH:mm" // Formato de entrada (como viene en tus datos)
                              ).format("DD/MM/YYYY HH:mm")}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </Card>
          </Grid>

          {/* Tabla de Precios Mínimos */}
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #fef6f5 0%, #f5e8e6 100%)",
                boxShadow: "0 8px 16px rgba(231, 76, 60, 0.1)",
                borderRadius: "12px",
                transition: "all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)",
                borderLeft: "4px solid #E74C3C", // Rojo intenso para minimos de propano
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0 12px 24px rgba(231, 76, 60, 0.2)",
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mb: 2,
                  }}
                >
                  <TrendingDownIcon
                    sx={{ color: "#FF8C42", fontSize: 28, mr: 1 }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      color: "#1F618D",
                      fontWeight: "700",
                      fontSize: "1.2rem",
                      letterSpacing: "0.5px",
                      background: "linear-gradient(to right, #E74C3C, #FF8C42)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    PRECIOS MÍNIMOS - PROPANO
                  </Typography>
                </Box>

                {loadingPropanoMenores ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "200px",
                    }}
                  >
                    <CircularProgress sx={{ color: "#E74C3C" }} />
                  </Box>
                ) : (
                  <TableContainer
                    component={Paper}
                    sx={{
                      borderRadius: "8px",
                      boxShadow: "none",
                      border: "1px solid #e0e0e0",
                      maxHeight: "400px",
                      overflow: "auto",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                        height: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#E74C3C",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          {[
                            "Vendedor",
                            "Patente",
                            "Cliente",
                            "Precio/Kilo",
                            "Fecha",
                          ].map((header, index) => (
                            <TableCell
                              key={index}
                              sx={{
                                fontWeight: "bold",
                                color: index === 3 ? "#E74C3C" : "#1F618D", // Rojo solo para precio
                                backgroundColor: "#fef6f5",
                                borderBottom: "2px solid #E74C3C",
                                minWidth: index === 2 ? "160px" : "auto",
                              }}
                            >
                              {header}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {propanoMenores.map((item, index) => (
                          <TableRow
                            key={index}
                            onClick={() => handleRowClick(item)}
                            sx={{
                              "&:nth-of-type(odd)": {
                                backgroundColor: "#ffffff",
                              },
                              "&:nth-of-type(even)": {
                                backgroundColor: "#fff5f4",
                              },
                              "&:hover": { backgroundColor: "#ffebee" },
                              transition: "background-color 0.2s ease",
                            }}
                          >
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {item.name_vendedor}
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              <Box
                                sx={{
                                  backgroundColor: "#FFE0B2",
                                  borderRadius: "4px",
                                  p: "2px 4px",
                                  display: "inline-block",
                                  fontWeight: "500",
                                }}
                              >
                                {item.patente}
                              </Box>
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {item.name_cliente_adi}
                            </TableCell>
                            <TableCell
                              sx={{
                                color: "#E74C3C",
                                fontSize: "0.875rem",
                                fontWeight: "600",
                              }}
                            >
                              ${item.precio_kilo.toFixed(2)}
                            </TableCell>
                            <TableCell
                              sx={{ color: "#2C3E50", fontSize: "0.875rem" }}
                            >
                              {moment(
                                item.ccd_fecha_mov,
                                "DD-MM-YYYY HH:mm" // Formato de entrada (como viene en tus datos)
                              ).format("DD/MM/YYYY HH:mm")}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default PanelSucursal;
